<template>
  <Loading v-if="loading" />
  <div class="logout" @click="logoutUser">
    <img src="@/assets/icons/Logout.svg" alt="" />
    <p>{{ $t('logout') }}</p>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { mapActions } from 'vuex';

import Loading from '@/views/Loading.vue';

@Options({
  components: {
    Loading
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapActions('account', ['logout']),
    ...mapActions('pharmacy', ['clearPharmacy']),
    async logoutUser() {
      this.loading = true;

      await this.logout();
      await this.clearPharmacy();
      localStorage.removeItem('id');

      this.loading = false;
    }
  }
})
export default class Logout extends Vue {}
</script>

<style scoped lang="scss">
.logout {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 48px;
  margin-bottom: 13px;
  background-color: $light-grey;
  cursor: pointer;
  img {
    width: 15px;
    height: 15px;
    margin: 0 12px 0 23px;
    background-color: $light-grey;
  }
  p {
    font-size: $fourteenSize;
    font-family: 'Ubuntu-Regular';
    background-color: $light-grey;
  }
  &:hover {
    background: $active;
  }
  &:hover p {
    background-color: $active;
  }
  &:hover img {
    background-color: $active;
  }
}
</style>
